/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/datatypes';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "UpdateTeamMemberRequest": {
            "fields": {
              "teamMemberId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "teamMember": {
                "type": ".squareup.team_api.TeamMember",
                "id": 2,
                "rule": "optional"
              },
              "fieldsToClear": {
                "type": "string",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "UpdateTeamMemberResponse": {
            "fields": {
              "teamMember": {
                "type": ".squareup.team_api.TeamMember",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.UpdateTeamMemberRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.UpdateTeamMemberResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents an update request for a `TeamMember` object.
 * --
 *
 * SOURCE UpdateTeamMemberRequest @ squareup/team_api/endpoints/update-team-member.proto at 22:1
 */
export const UpdateTeamMemberRequest = $root.lookupType('squareup.team_api.UpdateTeamMemberRequest');
fixType(UpdateTeamMemberRequest);
Builder.createAndAttachToType(UpdateTeamMemberRequest);
/**
 * --
 * @desc Represents a response from an update request containing the updated `TeamMember` object or error messages.
 * --
 *
 * SOURCE UpdateTeamMemberResponse @ squareup/team_api/endpoints/update-team-member.proto at 46:1
 */
export const UpdateTeamMemberResponse = $root.lookupType('squareup.team_api.UpdateTeamMemberResponse');
fixType(UpdateTeamMemberResponse);
Builder.createAndAttachToType(UpdateTeamMemberResponse);